import { render, staticRenderFns } from "./AppQuestionList.vue?vue&type=template&id=b5d9c988&scoped=true"
import script from "./AppQuestionList.vue?vue&type=script&lang=ts"
export * from "./AppQuestionList.vue?vue&type=script&lang=ts"
import style0 from "./AppQuestionList.vue?vue&type=style&index=0&id=b5d9c988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d9c988",
  null
  
)

export default component.exports